"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BillingFrequency = void 0;
const tslib_1 = require("tslib");
const tools_1 = require("../tools");
const createClient_graphql_1 = tslib_1.__importDefault(require("../gql/clients/mutations/createClient.graphql"));
const updateClient_graphql_1 = tslib_1.__importDefault(require("../gql/clients/mutations/updateClient.graphql"));
const deleteClient_graphql_1 = tslib_1.__importDefault(require("../gql/clients/mutations/deleteClient.graphql"));
const BaseModel_1 = tslib_1.__importDefault(require("./BaseModel"));
const Contact_1 = tslib_1.__importDefault(require("./Contact"));
var BillingFrequency;
(function (BillingFrequency) {
    BillingFrequency["NONE"] = "NONE";
    BillingFrequency["MONTHLY"] = "MONTHLY";
    BillingFrequency["WEEKLY"] = "WEEKLY";
    BillingFrequency["BI_WEEKLY"] = "BI_WEEKLY";
})(BillingFrequency = exports.BillingFrequency || (exports.BillingFrequency = {}));
class Client extends BaseModel_1.default {
    constructor() {
        super(...arguments);
        this.createMutation = createClient_graphql_1.default;
        this.updateMutation = updateClient_graphql_1.default;
    }
    defaults() {
        return {
            uuid: '',
            name: '',
            invoicePrefix: '',
            address: '',
            website: '',
            billingFrequency: {
                frequency: BillingFrequency.NONE,
                initialDate: null,
            },
            contact: new Contact_1.default(),
            organization: {
                uuid: tools_1.getStore().getters.organization.uuid,
            },
        };
    }
    delete() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this.hydrate(yield this.mutate(deleteClient_graphql_1.default, {
                uuid: this.uuid,
            }));
        });
    }
}
exports.default = Client;
//# sourceMappingURL=Client.js.map